/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './css/AdminPanel.css';
import { addPromo, deletePromo } from '../../Utils/RestUtils';
import {
  SUCCESS_STATUS,
  ERROR_TEXT,
} from '../../Utils/Constants/GlobalConstants';
import {
  NEW_PROMO,
  PROMO_CODE_PLACEHOLDER,
  PROMO_VALUE_PLACEHOLDER,
  PROMO_DAYS_PLACEHOLDER,
  ADD,
  DELETE,
  DELETE_CONFIRM,
  PROMO_CODE,
  PROMO_DISCOUNT,
  PROMO_USAGE,
  PROMO_CREATION_DATE,
  PROMO_ACTIVE_DAYS,
  NO_PROMO,
  PROMO_ADDED,
  PROMO_EXISTS,
  PROMO_FILL_FIELDS,
  EMPTY_VALUE,
} from '../../Utils/Constants/AdminConstants';

function Promo() {
  const [promo, setPromo] = useState([]);
  const [promoName, setPromoName] = useState('');
  const [promoValue, setPromoValue] = useState('');
  const [promoDays, setPromoDays] = useState('');
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const showMessage = (text, error) => {
    setMessage(text);
    setIsError(error);
  };

  const getPromo = () => {
    const token = window.localStorage.getItem('accessToken');
    axios
      .get('/api/promo/all', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((result) => {
        setPromo(result.data);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getPromo();
  }, []);

  const handleDelete = (id) => {
    if (deleteConfirmId !== id) {
      setDeleteConfirmId(id);
      return;
    }

    const token = window.localStorage.getItem('accessToken');
    setDeleteConfirmId(null);

    deletePromo(id, token)
      .then((response) => {
        if (response && response.data === SUCCESS_STATUS) {
          getPromo();
        } else {
          showMessage(ERROR_TEXT, true);
        }
      })
      .catch(() => {
        showMessage(ERROR_TEXT, true);
      });
  };

  const handlePromoName = (e) => {
    setPromoName(e.target.value);
  };

  const handlePromoValue = (e) => {
    if (!isNaN(e.target.value)) {
      setPromoValue(e.target.value);
    }
  };

  const handlePromoDays = (e) => {
    if (!isNaN(e.target.value)) {
      setPromoDays(e.target.value);
    }
  };

  const handleAdd = () => {
    const token = window.localStorage.getItem('accessToken');

    if (promoName.trim().length === 0 || promoValue.length === 0) {
      showMessage(PROMO_FILL_FIELDS, true);
      return;
    }

    addPromo(
      { name: promoName.trim(), value: promoValue, days: promoDays },
      token,
    )
      .then((response) => {
        if (response && response.data === SUCCESS_STATUS) {
          showMessage(PROMO_ADDED, false);
          setPromoName('');
          setPromoValue('');
          setPromoDays('');
          getPromo();
        } else {
          showMessage(PROMO_EXISTS, true);
        }
      })
      .catch(() => {
        showMessage(ERROR_TEXT, true);
      });
  };

  const getValueText = (value) =>
    (value || value === 0 ? value : EMPTY_VALUE);

  const getDeleteClass = (id) =>
    `ap_small_btn bm_text_14 ${
      deleteConfirmId === id ? 'ap_btn_danger' : 'light_gray_button'
    }`;

  const renderPromo = (promoList) =>
    promoList.map((item) => (
      <div key={`ap-promo-${item.id}`} className="ap_table_line">
        <div className="ap_promo_col dbm_text_16">{item.name}</div>
        <div className="ap_promo_col br_text_16">
          {getValueText(item.value)}
        </div>
        <div className="ap_promo_col br_text_16">
          {getValueText(item.usageCount)}
        </div>
        <div className="ap_promo_col br_text_16">
          {getValueText(item.creationDate)}
        </div>
        <div className="ap_promo_col br_text_16">
          {getValueText(item.activeDays)}
        </div>
        <div className="ap_promo_col ap_promo_col_action">
          <button
            type="button"
            className={getDeleteClass(item.id)}
            onClick={() => handleDelete(item.id)}
          >
            {deleteConfirmId === item.id ? DELETE_CONFIRM : DELETE}
          </button>
        </div>
      </div>
    ));

  return (
    <div>
      <div className="ap_panel mb_20">
        <div className="bm_text_18 mb_12">{NEW_PROMO}</div>
        <div className="ap_promo_form">
          <input
            className="ap_text_input"
            type="text"
            value={promoName}
            placeholder={PROMO_CODE_PLACEHOLDER}
            onChange={handlePromoName}
          />
          <input
            className="ap_text_input"
            type="text"
            value={promoValue}
            placeholder={PROMO_VALUE_PLACEHOLDER}
            onChange={handlePromoValue}
            maxLength={2}
          />
          <input
            className="ap_text_input"
            type="text"
            value={promoDays}
            placeholder={PROMO_DAYS_PLACEHOLDER}
            onChange={handlePromoDays}
          />
          <button
            type="button"
            className="ap_btn btn__yellow dbm_text_16"
            onClick={handleAdd}
          >
            {ADD}
          </button>
        </div>
        {message.length > 0 && (
          <div
            className={`ap_message br_text_14 ${
              isError ? 'ap_message_error' : ''
            }`}
          >
            {message}
          </div>
        )}
      </div>
      <div className="ap_card">
        <div className="ap_table_head">
          <div className="ap_promo_col gm_text_14">{PROMO_CODE}</div>
          <div className="ap_promo_col gm_text_14">{PROMO_DISCOUNT}</div>
          <div className="ap_promo_col gm_text_14">{PROMO_USAGE}</div>
          <div className="ap_promo_col gm_text_14">{PROMO_CREATION_DATE}</div>
          <div className="ap_promo_col gm_text_14">{PROMO_ACTIVE_DAYS}</div>
          <div className="ap_promo_col ap_promo_col_action" />
        </div>
        {promo.length > 0 ? (
          renderPromo(promo)
        ) : (
          <div className="ap_table_empty gr_text_16">{NO_PROMO}</div>
        )}
      </div>
    </div>
  );
}

export default Promo;
